import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
import emailApi from "@/api/email";

import NotFound from "@/views/NotFoundPage.vue";

const routes = [
  {
    path: "/verify-email",
    name: "verify-email",
    beforeEnter: async (to, from, next) => {
      try {
        const { data } = await emailApi.verify({ token: to.query.token });

        if (data.success) {
          next({ name: "login", query: { email: "success" } });
        } else {
          next({ name: "login", query: { email: "error" } });
        }
      } catch (error) {
        next({ name: "login", query: { email: "error" } });
      }
    },
  },
  {
    path: "/",
    redirect: "login",
    component: DashboardLayout,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: { requiresAuth: true },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import("../views/Dashboard.vue"),
      },
      {
        path: "/tambahtoko",
        name: "Tambah Toko",
        meta: { requiresAuth: true },
        component: () => import("../views/TambahToko.vue"),
      },
      {
        path: "/icons",
        name: "icons",
        component: () => import("../views/Icons.vue"),
      },
      {
        path: "/profile",
        name: "Profile",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/UserProfile.vue"),
      },
      {
        path: "/agen",
        name: "Agen",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Agen/Agen.vue"),
      },
      {
        path: "/addagen",
        name: "Tambah Agen",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Agen/AddAgen.vue"),
      },
      {
        path: "/editagen/:id",
        name: "Edit Agen",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Agen/EditAgen.vue"),
      },
      {
        path: "/bahan",
        name: "Bahan",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Bahan/Bahan.vue"),
      },
      {
        path: "/addbahan",
        name: "Tambah Bahan",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Bahan/AddBahan.vue"),
      },
      {
        path: "/stockmanagement",
        name: "Manajemen Stok",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Bahan/StockManagement.vue"),
      },
      {
        path: "/editbahan/:id",
        name: "Edit Bahan",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Bahan/EditBahan.vue"),
      },
      {
        path: "/menu",
        name: "Menu",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Menu/Menu.vue"),
      },
      {
        path: "/menu/food_test",
        name: "Food Test",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Menu/FoodTest.vue"),
      },
      {
        path: "/addmenu",
        name: "Tambah Menu",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Menu/AddMenu.vue"),
      },
      {
        path: "/editmenu/:id",
        name: "Edit Menu",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Menu/EditMenu.vue"),
      },
      {
        path: "/diskon",
        name: "Diskon",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Diskon/Diskon.vue"),
      },
      {
        path: "/adddiskon",
        name: "Tambah Diskon",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Diskon/AddDiskon.vue"),
      },
      {
        path: "/editdiskon/:id",
        name: "Edit Diskon",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Diskon/EditDiskon.vue"),
      },
      {
        path: "/member",
        name: "Member",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Member/Member.vue"),
      },
      {
        path: "/generatecard",
        name: "Generate Qr-Code",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Member/GenerateCard.vue"),
      },
      {
        path: "/addmember",
        name: "Tambah Member",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Member/AddMember.vue"),
      },
      {
        path: "/editmember/:id",
        name: "Edit member",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Member/EditMember.vue"),
      },
      {
        path: "/settingtoko",
        name: "setting toko",
        component: () => import("../views/Pages/TokoProfile.vue"),
      },
      {
        path: "/settingwebsite",
        name: "setting website",
        component: () => import("../views/Pages/WebsiteProfile.vue"),
      },
      {
        path: "/pegawai",
        name: "Pegawai",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Pegawai/Pegawai.vue"),
      },
      {
        path: "/addpegawai",
        name: "Tambah Pegawai",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Pegawai/AddPegawai.vue"),
      },
      {
        path: "/editpegawai/:id",
        name: "Edit Pegawai",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Pegawai/EditPegawai.vue"),
      },
      {
        path: "/pegawai/benefit",
        name: "Benefit Pegawai",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Pegawai/BenefitPegawai.vue"),
      },
      {
        path: "/keuangan",
        name: "Keuangan",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Keuangan/Keuangan.vue"),
      },
      {
        path: "/kasir",
        name: "Kasir",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Kasir/Kasir.vue"),
      },
      {
        path: "/laporan",
        name: "laporan",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Laporan/Laporan.vue"),
      },
      {
        path: "/absen",
        name: "absen",
        meta: { requiresAuth: true },
        component: () => import("../views/Pages/Absen"),
      },
      {
        path: "/maps",
        name: "maps",
        component: () => import("../views/GoogleMaps.vue"),
      },
      {
        path: "/tables",
        name: "tables",
        component: () => import("../views/RegularTables.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/Pages/Login.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () => import("../views/Pages/Register.vue"),
      },
      { path: "*", component: NotFound },
    ],
  },
];

export default routes;
